import './_style.scss';

import React from 'react';
import { Input, Modal, ModalBody, ModalHeader, ModalFooter, Button } from 'reactstrap';

const ModalEnviarProtocolo = ({ isOpen, toggle, envelope, confirmar }) => {  
  return (
    <Modal isOpen={isOpen} toggle={toggle} className="modal-md modal-default">
      <ModalHeader toggle={toggle}>Informe o número do envelope</ModalHeader>
      <ModalBody>                   
        <div>
          <Input
                type="text"
                pattern="[0-9]*"
                maxLength="13"
                value={envelope.value}
                onChange={envelope.onChange}
                className="form-control mb-0"
                placeholder="Número do Envelope"
                onKeyPress={envelope.OnKeyPress}
              />

        </div>

      </ModalBody>
      <ModalFooter>
        <Button className="btn_success" disabled={confirmar.disabled} onClick={confirmar.onClick}>Confirmar</Button>
        <Button className="btn_danger" onClick={toggle}>Fechar</Button>
      </ModalFooter>
    </Modal>
  );
}

export default ModalEnviarProtocolo;
